(()=>{
const drag=track=>{
 if(!track||track.dataset.dragReady)return;track.dataset.dragReady='1';
 let start=null,moved=false,suppressClick=false;
 track.addEventListener('click',e=>{if(suppressClick){e.preventDefault();e.stopPropagation();suppressClick=false;}},true);
 track.addEventListener('dragstart',e=>e.preventDefault());
 track.addEventListener('pointerdown',e=>{
  if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('button,video,iframe,model-viewer'))return;
  start={x:e.clientX,left:track.scrollLeft,id:e.pointerId};moved=false;suppressClick=false;
 });
 track.addEventListener('pointermove',e=>{
  if(!start)return;const dx=e.clientX-start.x;
  if(Math.abs(dx)>5){moved=true;track.dataset.dragging='1';track.setPointerCapture(e.pointerId);track.style.scrollSnapType='none';track.scrollLeft=start.left-dx;}
 });
 const finish=()=>{
  if(!start)return;const id=start.id;start=null;track.style.scrollSnapType='';
  if(track.hasPointerCapture(id))track.releasePointerCapture(id);
  if(moved){suppressClick=true;track.scrollTo({left:Math.round(track.scrollLeft/track.clientWidth)*track.clientWidth,behavior:'auto'});setTimeout(()=>{suppressClick=false;},100);}
  moved=false;delete track.dataset.dragging;
 };
 track.addEventListener('pointerup',finish);track.addEventListener('pointercancel',finish);
 track.addEventListener('pointerleave',()=>{if(!moved)start=null;});
 track.addEventListener('keydown',e=>{
  if(e.target!==track||!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();
  track.scrollBy({left:track.clientWidth*(e.key==='ArrowRight'?1:-1),behavior:'auto'});
 });
};
if(!customElements.get('rbw-swipe'))customElements.define('rbw-swipe',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  const track=this.querySelector('.rbw-swipe-track');drag(track);
  const prev=this.querySelector('[data-swipe-prev]'),next=this.querySelector('[data-swipe-next]');
  const update=()=>{const i=Math.round(track.scrollLeft/track.clientWidth);if(prev){prev.disabled=i===0;prev.hidden=i===0;}if(next){next.disabled=i>=track.children.length-1;next.hidden=i>=track.children.length-1;}};
  track.addEventListener('scroll',update,{passive:true});
  for(const [button,direction] of [[prev,-1],[next,1]])button?.addEventListener('click',()=>track.scrollTo({left:(Math.round(track.scrollLeft/track.clientWidth)+direction)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}));
  const second=track.children[1]?.querySelector('img');
  if(second){
   const preview=second.cloneNode(true);preview.className='rbw-hover-preview';preview.alt='';preview.setAttribute('aria-hidden','true');preview.removeAttribute('id');this.append(preview);
   const fine=matchMedia('(hover:hover) and (pointer:fine)');
   this.addEventListener('pointerenter',()=>{if(fine.matches&&Math.round(track.scrollLeft/track.clientWidth)===0)this.classList.add('rbw-hovering');});
   this.addEventListener('pointerleave',()=>this.classList.remove('rbw-hovering'));
   this.addEventListener('pointerdown',()=>this.classList.remove('rbw-hovering'));
   track.addEventListener('scroll',()=>this.classList.remove('rbw-hovering'),{passive:true});
  }
  update();
 }
});
const init=()=>document.querySelectorAll('.rp-slides').forEach(drag);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();